import React, { useState } from "react";
import ParticipantListItem from "./ParticipantListItem";
const UserParticipant = (props) => {
    const [isDetailsOpened, setIsDetailsOpened] = useState(false);
    const onItemClickHandler = () => {
        setIsDetailsOpened((prev) => !prev);
    };
    return (React.createElement("div", { 
        // @ts-ignore
        role: "button", onClick: onItemClickHandler },
        React.createElement(ParticipantListItem, { ...props, isDetailsOpened: isDetailsOpened, showJersey: props.showJersey })));
};
export default UserParticipant;
